//项目定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 项目类型
 */
class Type extends UltMeta {
    BUY = new Meta(1, "采购项目");
    SELL = new Meta(2, "销售项目");
}

export const TYPE = new Type();

/**
 * 项目状态
 */
class ProjectState extends UltMeta {
    PENDING = new Meta(1, "合同待签约");
    PROCESSING = new Meta(2, "履约中");
    FINISHED = new Meta(3, "已结清");
}

export const PROJECT_STATE = new ProjectState();

/**
 * 项目状态
 */
class ProjectStateBank extends UltMeta {
    PROCESSING = new Meta(2, "履约中");
    FINISHED = new Meta(3, "收款完成");
}

export const PROJECT_STATE_BANK = new ProjectStateBank();

/**
 * 保存方式
 */
class ProjectSubmitType extends UltMeta {
    SAVE_AS_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_SUBMIT = new Meta(2, "保存并提交");
}

export const PROJECT_SUBMIT_TYPE = new ProjectSubmitType();

class ProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PURCHASE_INFO = new Meta(3, "采购信息", "PaymentInfo");
    SALES_INFO = new Meta(4, "销售信息", "DeliveryInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
    PROJECT_ANALYSIS = new Meta(6, "项目分析", "ProjectAnalysis");
    LOGISTICS_ANALYSIS = new Meta(7, "物流分析", "LogisticsAnalysis");
    // RECONCILIATION_INFO = new Meta(6, "结算明细", "ReconciliationInfo");
    // BILLING_INFO = new Meta(7, "开票明细", "InvoiceInfo");
}

export const PROJECT_TAB_ITEMS = new ProjectTabItems();

/** 银行端项目详情只支持既有内容页，不暴露供应链/SaaS 的物流分析入口。 */
class BankProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    PURCHASE_INFO = new Meta(3, "采购信息", "PaymentInfo");
    SALES_INFO = new Meta(4, "销售信息", "DeliveryInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
    PROJECT_ANALYSIS = new Meta(6, "项目分析", "ProjectAnalysis");
}

export const BANK_PROJECT_TAB_ITEMS = new BankProjectTabItems();

class StockProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
    PROJECT_ANALYSIS = new Meta(6, "项目分析", "ProjectAnalysis");
}

export const STOCK_PROJECT_TAB_ITEMS = new StockProjectTabItems();

// dashboard中销售项目利润排行-项目状态

class DashboardProjectState extends UltMeta {
    PROCESSING = new Meta(2, "履约中");
    FINISHED = new Meta(3, "已结清");
}

export const DASHBOARD_PROJECT_STATE = new DashboardProjectState();

// 出库条件
class OutBoundConditions extends UltMeta {
    FULL_PAYMENT = new Meta(1, "全款结算");
    PARTIAL_PAYMENT = new Meta(2, "部分付款");
    PLEDGE = new Meta(3, "货物质押");
}

export const OUT_BOUND_CONDITIONS = new OutBoundConditions();

// 控货比要求

class ControlRatioWay extends UltMeta {
    COUNT = new Meta(1, "按数量/重量");
    AMOUNT = new Meta(2, "按金额");
}

export const CONTROL_RATIO_TYPE = new ControlRatioWay();

// 项目-可预估提货余额表单 -加减方向
class EstimatedDirection extends UltMeta {
    ADD = new Meta(1, "加");
    SUBTRACT = new Meta(2, "减");
}

export const ESTIMATED_DIRECTION = new EstimatedDirection();

// 录入企业参数
class RecordedParam extends UltMeta {
    UP = new Meta(1, "上游为录入企业");
    DOWN = new Meta(2, "下游为录入企业");
}

export const RECORDED_PARAM = new RecordedParam();

/**
 * 账期计算方式
 */
class SettlePeriodWay extends UltMeta {
    MONTH = new Meta(1, "按月");
    DAY = new Meta(2, "按天");
}

export const SETTLE_PERIOD_WAY = new SettlePeriodWay();

// ============= 监管项目 =============

/**
 * 委托方类型: 往来企业， 关联企业
 */

class EntrustType extends UltMeta {
    DEALINGS_ENTERPRISE = new Meta(1, "往来企业");
    MAIN_BODY = new Meta(2, "关联企业");
}

export const ENTRUST_TYPE = new EntrustType();

/**
 * 仓储管理-项目管理
 */

class StoreProjectTabItems extends UltMeta {
    PROJECT_INFO = new Meta(1, "项目概况");
    CONTRACT_INFO = new Meta(2, "合同信息", "ContractInfo");
    STORAGE_INFO = new Meta(5, "仓储信息", "StorageInfo");
    // 仓储项目详情分析页签，供供应链端与管理后台共用。
    PROJECT_ANALYSIS = new Meta(6, "项目分析", "ProjectAnalysis");
}

export const STORE_PROJECT_TAB_ITEMS = new StoreProjectTabItems();

// 往来企业主体类型下拉选项
class QueryBodyType extends UltMeta {
    CUSTOMER = new Meta(1, "客户");
    SUPPLIER_CHAIN = new Meta(2, "供应链");
    ALL = new Meta(3, "客户和供应链");
}

export const QUERY_BODY_TYPE = new QueryBodyType();

// 摄像头权限：1.开放给所有客户 2.开放给部分客户 0.不开放
class CameraPermission extends UltMeta {
    ALL = new Meta(1, "开放给所有客户");
    PART = new Meta(2, "开放给部分客户");
    NONE = new Meta(3, "不开放");
}

export const CAMERA_PERMISSION = new CameraPermission();
